import {Component, forwardRef, Injector} from "@angular/core";
import {SiteSearchModel} from "../site-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {SiteSearchPageComponent} from "../site-search-page/site-search-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";


const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SiteSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-site-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(SiteSearchModel)
    ]
})
export class SiteSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SiteSearchModel> {
    constructor(model: SiteSearchModel, injector: Injector) {
        super(model, injector, "groupName", "groupName");
        this.labelSearchField = "groupNameFilter";
        this.extendedSearchComponent = SiteSearchPageComponent;
    }
}
